import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import Icon from 'components/UI/Icon';
import LangSwitch from 'components/UI/LangSwitch';
import Button from 'components/UI/Button';
import BurgerBtn from 'components/UI/BurgerBtn';
import Navigation from './Navigation';

import useLocaleTxt from 'hooks/useLocaleTxt';

import * as styles from './header.module.scss';
import { useContextDispatch, ACTIONS } from '@/context';

import useLocale from 'hooks/useLocale';

const Header = (props) => {
  const dispatch = useContextDispatch();
  const locale = useLocale();

  const localeTxt = useLocaleTxt();

  const openGetCirrusModal = () => {
    dispatch({ type: ACTIONS.setGetCirrusoftModal, value: true });
  };

  return (
    <header className={classnames(props.className, styles.header)}>
      <div className={classnames(styles.inner, 'cr-wrap')}>
        <Link
          to={locale.path}
          className={classnames(styles.logo, 'cr-bounce-scale')}
        >
          <Icon name={'cirrus-logo-black'} />
        </Link>

        <div className={classnames(styles.controls, 'cr-desktop-only')}>
          <Navigation locale={locale} />
          <Button
            className={classnames(styles.btn, 'cr-btn--default')}
            onClick={openGetCirrusModal}
          >
            {localeTxt['GET_CIRRUSOFT']}
          </Button>
          <LangSwitch />
        </div>

        <BurgerBtn className={classnames('cr-mobile-only')} />
      </div>
    </header>
  );
};

export default Header;
